/**
 * Front-end behaviour for mea/news-feed, archive layout only.
 *
 * render.php puts EVERY published news item on the page, so the section is
 * complete and correct with this file absent or blocked. All the script does is
 * hide the rows past the first page and offer a button that brings them back;
 * nothing here creates, fetches or orders a row. Same contract
 * mea/careers-feed's filter pills and mea/insights-featured's archive already
 * work under.
 *
 * Markup rendered by render.php:
 *
 *   <section class="mea-news-feed mea-news-feed--layout-archive">
 *     <ul data-mea-news-list>
 *       <li class="mea-news-feed__item">
 *     </ul>
 *     <div data-mea-news-more data-page-size="10" hidden>
 *       <p role="status" data-mea-news-status data-template="Showing {shown} of {total} items.">
 *       <button data-mea-news-load>
 *     </div>
 *   </section>
 */

/**
 * Fill {token} placeholders in an editable copy string.
 *
 * @param {string} template Copy from a block attribute.
 * @param {Object} values   Token name to replacement value.
 * @return {string} The filled string.
 */
function fill( template, values ) {
	return Object.keys( values ).reduce( function ( text, token ) {
		return text.split( '{' + token + '}' ).join( values[ token ] );
	}, template || '' );
}

/**
 * Wire one archive instance.
 *
 * @param {HTMLElement} actions The `[data-mea-news-more]` group, which
 *                              render.php ships `hidden`.
 */
function initArchive( actions ) {
	const section = actions.closest( '.mea-news-feed' );
	const list = section && section.querySelector( '[data-mea-news-list]' );
	if ( ! list ) {
		return;
	}

	const items = Array.prototype.slice.call(
		list.querySelectorAll( '.mea-news-feed__item' )
	);
	const pageSize = Math.max(
		1,
		parseInt( actions.getAttribute( 'data-page-size' ), 10 ) || 10
	);

	// Nothing to narrow: leave the list alone and the control hidden, so a dead
	// button is never reachable.
	if ( items.length <= pageSize ) {
		return;
	}

	const button = actions.querySelector( '[data-mea-news-load]' );
	const status = actions.querySelector( '[data-mea-news-status]' );
	let shown = pageSize;

	function apply() {
		items.forEach( function ( item, index ) {
			// The `hidden` attribute rather than a class: it takes the row out
			// of the accessibility tree and the tab order as well as the layout.
			item.hidden = index >= shown;
		} );

		if ( status ) {
			status.textContent = fill( status.getAttribute( 'data-template' ), {
				shown: String( shown ),
				total: String( items.length ),
			} );
		}

		// Everything is out: hide the button rather than disable it, so a
		// control that can no longer do anything is not reachable either.
		if ( shown >= items.length && button ) {
			button.hidden = true;
		}
	}

	if ( button ) {
		button.addEventListener( 'click', function () {
			const first = shown;
			shown = Math.min( items.length, shown + pageSize );
			apply();

			// Send the reader to the top of what just appeared rather than
			// leaving them where the button used to be.
			const link = items[ first ] && items[ first ].querySelector( 'a' );
			if ( link ) {
				link.focus( { preventScroll: true } );
			}
		} );
	}

	apply();
	actions.hidden = false;
}

function boot() {
	document.querySelectorAll( '[data-mea-news-more]' ).forEach( initArchive );
}

if ( 'loading' === document.readyState ) {
	document.addEventListener( 'DOMContentLoaded', boot );
} else {
	boot();
}
